<anagrafica-parte-form
  (parteChange)="onEmitAnagrafica($event)"
  *ngIf="currentForm == form.ANAGRAFICA"></anagrafica-parte-form>
<step-soggetti-terzi-form-associativa
[parte]="parte"
(altraParteChange)="onEmitAssociativa($event)"
*ngIf="currentForm == form.ASSOCIATIVA"></step-soggetti-terzi-form-associativa>
